/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

/*@ngInject*/
export default function GatewayLogPayloadController($mdDialog, types, utils, payload, showingCallback) {
    var vm = this;

    vm.$onInit = function () {
        vm.gatewayLogPayloadText = null;

        vm.close = close;

        showingCallback.onShowing = function () {
            if (payload) {
                vm.gatewayLogPayloadText = angular.toJson(payload, true);
            }
        };

        vm.gatewayLogPayloadOptions = {
            useWrapMode: false,
            mode: 'json',
            showGutter: false,
            showPrintMargin: false,
            theme: 'github',
            advanced: {
                enableSnippets: false,
                enableBasicAutocompletion: false,
                enableLiveAutocompletion: false
            },
            onLoad: function (_ace) {
                vm.editor = _ace;
            }
        };
    };

    function close () {
        $mdDialog.hide();
    }
}



// WEBPACK FOOTER //
// ./src/app/gateway-log/gateway-log-payload.controller.js